import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var MegaphoneIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.707 11.1209C3.939 11.0779 3.239 11.0479 2.743 11.0279C2.328 11.0099 2 10.6679 2 10.2529C2 9.31387 2 7.71487 2 6.78187C2 6.36987 2.321 6.03087 2.732 6.00687C4.213 5.92487 7.552 5.72087 9.028 5.46287C10.589 5.19087 12.341 4.28887 13.56 4.02687C13.912 3.95087 14.278 4.03887 14.558 4.26487C14.838 4.49187 15 4.83287 15 5.19387V6.99987C15.552 6.99987 16 7.44787 16 7.99987C16 8.32187 16 8.67787 16 8.99987C16 9.55187 15.552 9.99987 15 9.99987V11.8509C15 12.2119 14.838 12.5529 14.558 12.7799C14.278 13.0069 13.912 13.0939 13.56 13.0189C13.56 13.0189 10.57 11.7759 8.989 11.4999C8.663 11.4429 8.247 11.3909 7.782 11.3449L9 14.9999H6L4.707 11.1209Z"
  }));
});
MegaphoneIcon.displayName = 'MegaphoneIcon';
export default MegaphoneIcon;